import {useSearchOptions} from "../../../hooks/useSearchOptions";
import {userListURL} from "./userTable.constants";

export const useUserSearchOptions = () => {
  const options = useSearchOptions(userListURL, [
    "username",
    "email",
    "first_name",
    "last_name",
  ]);

  const searchOptions = [
    {
      category: {label: "Username", value: "username"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.username,
    },
    {
      category: {label: "Email", value: "email"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.email,
    },
    {
      category: {label: "First Name", value: "first_name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.first_name,
    },
    {
      category: {label: "Last Name", value: "last_name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.last_name,
    },
    {
      category: {label: "Is Active", value: "is_active"},
      operator: ["="],
      options: [
        {label: "true", value: true},
        {label: "false", value: false},
      ],
    },
  ];

  return {searchOptions};
};
